import {useMemo, useState} from "react";
import {css, useTheme} from "@emotion/react";

import {CenterBox} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Chart, getDefaultXAxisOptions, getDefaultYAxisOptions} from "@pg-mono/charts";
import {decimalSeparatorThousand, formatDate, priceM2Format} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {RoomsType} from "../PricesChart";

interface IProps {
    pricesData: IPriceReportAveragePrices[] | null;
    roomsType: RoomsType;
}

export const PricesChartChart = (props: IProps) => {
    const {pricesData, roomsType} = props;

    const [showTooltip, setShowTooltip] = useState(true);

    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const getLabelProps = (formatter: (value: string | number) => string) => {
        return {
            enabled: true,
            style: {
                color: theme.colors.gray[700],
                fontSize: "10px",
                fontFamily: "Poppins"
            },
            formatter: ({value}: {value: string | number}) => formatter(value)
        };
    };

    const chartData = useMemo(() => {
        if (pricesData) {
            const dataLastIndex = pricesData.length - 1;
            return pricesData.map((record, index) => {
                const firstOrLast = [0, dataLastIndex].includes(index);

                let price;
                switch (roomsType) {
                    case RoomsType.ONE_ROOM:
                        price = record.avg_price_m2_studio;
                        break;
                    case RoomsType.TWO_ROOMS:
                        price = record.avg_price_m2_2_rooms;
                        break;
                    case RoomsType.THREE_ROOMS:
                        price = record.avg_price_m2_3_rooms;
                        break;
                    case RoomsType.FOUR_OR_MORE_ROOMS:
                        price = record.avg_price_m2_4_plus_rooms;
                        break;
                    default:
                        price = record.avg_price_m2;
                }

                const formattedPrice = priceM2Format(price, {precision: 0});

                const options = firstOrLast
                    ? {
                          marker: {states: {hover: {enabled: false}}},
                          dataLabels: {
                              enabled: true,
                              formatter: () => `${formattedPrice}`,
                              verticalAlign: "bottom",
                              y: -4
                          },
                          events: {
                              mouseOver: () => setShowTooltip(false)
                          }
                      }
                    : {
                          marker: {enabled: false, states: {hover: {enabled: true}}},
                          events: {
                              mouseOver: () => setShowTooltip(true)
                          }
                      };

                return {x: index, y: price, ...options};
            });
        }
        return [];
    }, [pricesData, roomsType]);

    const yAxisOptions = {
        ...getDefaultYAxisOptions(),
        labels: getLabelProps((value) => decimalSeparatorThousand(value.toString()))
    };

    const xAxisOptions = useMemo(() => {
        return {
            ...getDefaultXAxisOptions(),
            labels: getLabelProps((value: string | number) => {
                if (typeof value === "number" && isFinite(value)) {
                    const date = pricesData && pricesData[value]?.date;

                    return formatDate(date, isMobile ? "LLL" : "LLLL");
                }
                return value.toString();
            }),
            tickInterval: 1
        };
    }, [pricesData, isMobile]);

    return (
        <div css={chartHolder}>
            <Chart
                height="300px"
                options={{
                    title: {text: ""},
                    xAxis: xAxisOptions,
                    yAxis: yAxisOptions,
                    plotOptions: {
                        spline: {
                            marker: {
                                radius: 6
                            }
                        }
                    },
                    series: [
                        {
                            type: "spline",
                            color: theme.colors.highlight,
                            lineWidth: 3,
                            showInLegend: false,
                            dataLabels: {
                                useHTML: true,
                                style: {
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    color: theme.colors.gray[700]
                                }
                            },
                            data: chartData
                        }
                    ],
                    tooltip: {
                        enabled: showTooltip,
                        borderColor: "transparent",
                        backgroundColor: "#FFF",
                        style: {
                            color: theme.colors.gray[700],
                            fontSize: "1rem"
                        },
                        // Use anonymous function in order to access correct context (`this`)
                        formatter: function () {
                            return this.point.y ? priceM2Format(this.point.y, {precision: 0}) : "";
                        }
                    }
                }}
                loader={
                    pricesData ? null : (
                        <CenterBox height="300px">
                            <Loader size="lg" />
                        </CenterBox>
                    )
                }
            />
        </div>
    );
};

const chartHolder = css`
    width: 100%;
    max-width: 1080px;
    height: 300px;
    ${flexAbsoluteCenter};
    ${mb(2)};
`;
import {useMemo, useState} from "react";
import {css, useTheme} from "@emotion/react";

import {CenterBox} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Chart, getDefaultXAxisOptions, getDefaultYAxisOptions} from "@pg-mono/charts";
import {decimalSeparatorThousand, formatDate, priceM2Format} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {RoomsType} from "../PricesChart";

interface IProps {
    pricesData: IPriceReportAveragePrices[] | null;
    roomsType: RoomsType;
}

export const PricesChartChart = (props: IProps) => {
    const {pricesData, roomsType} = props;

    const [showTooltip, setShowTooltip] = useState(true);

    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const getLabelProps = (formatter: (value: string | number) => string) => {
        return {
            enabled: true,
            style: {
                color: theme.colors.gray[700],
                fontSize: "10px",
                fontFamily: "Poppins"
            },
            formatter: ({value}: {value: string | number}) => formatter(value)
        };
    };

    const chartData = useMemo(() => {
        if (pricesData) {
            const dataLastIndex = pricesData.length - 1;
            return pricesData.map((record, index) => {
                const firstOrLast = [0, dataLastIndex].includes(index);

                let price;
                switch (roomsType) {
                    case RoomsType.ONE_ROOM:
                        price = record.avg_price_m2_studio;
                        break;
                    case RoomsType.TWO_ROOMS:
                        price = record.avg_price_m2_2_rooms;
                        break;
                    case RoomsType.THREE_ROOMS:
                        price = record.avg_price_m2_3_rooms;
                        break;
                    case RoomsType.FOUR_OR_MORE_ROOMS:
                        price = record.avg_price_m2_4_plus_rooms;
                        break;
                    default:
                        price = record.avg_price_m2;
                }

                const formattedPrice = priceM2Format(price, {precision: 0});

                const options = firstOrLast
                    ? {
                          marker: {states: {hover: {enabled: false}}},
                          dataLabels: {
                              enabled: true,
                              formatter: () => `${formattedPrice}`,
                              verticalAlign: "bottom",
                              y: -4
                          },
                          events: {
                              mouseOver: () => setShowTooltip(false)
                          }
                      }
                    : {
                          marker: {enabled: false, states: {hover: {enabled: true}}},
                          events: {
                              mouseOver: () => setShowTooltip(true)
                          }
                      };

                return {x: index, y: price, ...options};
            });
        }
        return [];
    }, [pricesData, roomsType]);

    const yAxisOptions = {
        ...getDefaultYAxisOptions(),
        labels: getLabelProps((value) => decimalSeparatorThousand(value.toString()))
    };

    const xAxisOptions = useMemo(() => {
        return {
            ...getDefaultXAxisOptions(),
            labels: getLabelProps((value: string | number) => {
                if (typeof value === "number" && isFinite(value)) {
                    const date = pricesData && pricesData[value]?.date;

                    return formatDate(date, isMobile ? "LLL" : "LLLL");
                }
                return value.toString();
            }),
            tickInterval: 1
        };
    }, [pricesData, isMobile]);

    return (
        <div css={chartHolder}>
            <Chart
                height="300px"
                options={{
                    title: {text: ""},
                    xAxis: xAxisOptions,
                    yAxis: yAxisOptions,
                    plotOptions: {
                        spline: {
                            marker: {
                                radius: 6
                            }
                        }
                    },
                    series: [
                        {
                            type: "spline",
                            color: theme.colors.highlight,
                            lineWidth: 3,
                            showInLegend: false,
                            dataLabels: {
                                useHTML: true,
                                style: {
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    color: theme.colors.gray[700]
                                }
                            },
                            data: chartData
                        }
                    ],
                    tooltip: {
                        enabled: showTooltip,
                        borderColor: "transparent",
                        backgroundColor: "#FFF",
                        style: {
                            color: theme.colors.gray[700],
                            fontSize: "1rem"
                        },
                        // Use anonymous function in order to access correct context (`this`)
                        formatter: function () {
                            return this.point.y ? priceM2Format(this.point.y, {precision: 0}) : "";
                        }
                    }
                }}
                loader={
                    pricesData ? null : (
                        <CenterBox height="300px">
                            <Loader size="lg" />
                        </CenterBox>
                    )
                }
            />
        </div>
    );
};

const chartHolder = css`
    width: 100%;
    max-width: 1080px;
    height: 300px;
    ${flexAbsoluteCenter};
    ${mb(2)};
`;
